import {
	Grid2,
	IconButton,
	makeStyles,
	Paper,
	Skeleton,
	styled,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
} from '@mui/material';
import { useMainCustomStyle } from '../assets/theme/Theme';
import SideNavigationBar from '../components/SideNavigationBar';
import { useEffect, useRef, useState } from 'react';
import { ChatLeadsListResponse, ChatLead } from '../types';
import { fetchChatHistoryList, fetchChatLeads } from '../services/ApiService';
import _ from 'lodash';
import { convertTo12HourTime, dateFormatter } from '../Utils/Helpers';

function ChatLeads() {
	const mainDivStyle = useMainCustomStyle();
	const [chatLeadList, setChatLeadList] = useState<Array<ChatLead>>([]);
	const [rowsPerPage, setRowsPerPage] = useState(15);
	const [page, setPage] = useState(0);
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		getChatLeads();
	}, []);

	async function getChatLeads() {
		setIsLoading(true);
		const data: Array<ChatLeadsListResponse> = await fetchChatLeads();
		const filteredData: ChatLead[] = data
			.filter(item => !!item.user_info)
			.map(item => JSON.parse(item.user_info!) as ChatLead);
		setChatLeadList(filteredData);
		setIsLoading(false);
	}

	const handleChangePage = (
		event: React.MouseEvent<HTMLButtonElement> | null,
		newPage: number,
	) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<>
			<SideNavigationBar />
			<div style={mainDivStyle}>
				<Grid2 container paddingLeft={'20px'} paddingRight={'20px'}>
					<Grid2
						container
						sx={{ paddingLeft: '10px', width: '100%' }}>
						<TableContainer
							component={Paper}
							style={{
								boxShadow: 'none',
							}}>
							<Table
								sx={{ minWidth: 700, width: '100%' }}
								aria-label="customized table">
								<TableHead>
									<TableRow>
										<StyledTableCell align="center">
											<TableHeaderText>
												Name
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Email
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Country
											</TableHeaderText>
										</StyledTableCell>
										<StyledTableCell align="center">
											<TableHeaderText>
												Company
											</TableHeaderText>
										</StyledTableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{isLoading ? (
										<StyledTableRow>
											{[...Array(4)].map((_, index) => (
												<StyledTableCell
													key={index}
													align="center">
													<Skeleton
														animation="wave"
														style={{
															borderRadius: '5px',
														}}
														variant="rounded"
													/>
												</StyledTableCell>
											))}
										</StyledTableRow>
									) : chatLeadList &&
									  chatLeadList.length > 0 ? (
										chatLeadList
											.slice(
												page * rowsPerPage,
												page * rowsPerPage +
													rowsPerPage,
											)
											.map((chat, index) => {
												return (
													<StyledTableRow key={index}>
														<StyledTableCell align="center">
															<TableRowText>
																{chat.name}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{chat.email}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{chat.country}
															</TableRowText>
														</StyledTableCell>
														<StyledTableCell align="center">
															<TableRowText>
																{chat.company}
															</TableRowText>
														</StyledTableCell>
													</StyledTableRow>
												);
											})
									) : (
										<StyledTableRow>
											<StyledTableCell
												colSpan={5}
												align="center">
												<TableRowText>
													No data available
												</TableRowText>
											</StyledTableCell>
										</StyledTableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[]}
							component="div"
							count={chatLeadList ? chatLeadList.length : 0}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</Grid2>
				</Grid2>
			</div>
		</>
	);
}

export const StyledTableCell = styled(TableCell)(() => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#FFFFFF',
		color: 'rgba(0, 0, 0, 0.5)',
		paddingTop: '20px',
		fontSize: 12,
		fontWeight: 600,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		fontWeight: 400,
		color: '#000000',
		maxWidth: 80,
	},
}));

export const StyledTableRow = styled(TableRow)(() => ({
	'&:nth-of-type(odd)': {
		background:
			'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #C2C9D1',
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

export const TableHeaderText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '600',
	color: 'rgba(0, 0, 0, 0.5)',
}));

export const TableRowText = styled(Typography)(() => ({
	fontSize: '12px',
	fontWeight: '400',
	color: 'rgba(0, 0, 0, 1)',
}));

export default ChatLeads;
